<template>
  <div class="container__wrapper container__wrapper--topbar-adjust">
    <Topbar>
      <div class="topbar__panel">
        <div class="topbar__heading">
          <h1>Playlists ({{ playlist.data.name }})</h1>
          <Breadcrumb />
        </div>
        <div class="button-group">
          <button
            class="button button--light button--pill"
            @click.prevent="openModal()"
          >
            <span class="button__icon"><i class="icon icon-e-add" /></span>
            <span class="button__label">Select Assets</span>
          </button>
        </div>
      </div>
    </Topbar>

    <Sidebar />

    <div class="content">
      <div class="content__wrapper">
        <NoContent v-if="!assets.data.length">
          <InertiaLink
            class="button u-br"
            href="/clients/create"
          >
            <span class="button__icon">
              <i class="icon icon-e-add" />
            </span>
            <span class="button__label">New Asset</span>
          </InertiaLink>
        </NoContent>

        <div class="media">
          <div
            v-for="asset in playlist.data.assets"
            :key="asset.id"
            class="media__item"
          >
            <div class="media__block">
              <div class="media__body">
                <div class="media__preview">
                  <div class="media__file-type">{{ asset.mime_type }}</div>
                  <img :src="asset.thumbnail" alt="">
                </div>
                <div class="media__content">
                  <div class="data-group">
                    <span class="data data--highlight">{{ asset.name }}</span>
                    <span class="data data--muted">{{ asset.size | numeral('0.00 b') }}</span>
                  </div>
                </div>
              </div>
              <div class="media__foot">
                <div class="data-group">
                  <span class="data data--muted">Created {{ asset.created_at | moment('from') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from '@components/Topbar'
import Sidebar from '@components/Sidebar'
import Breadcrumb from '@components/shared/Breadcrumb'
import Dashboard from '@layouts/Dashboard'
import NoContent from '@components/shared/NoContent'
import PlaylistModal from '@components/modals/PlaylistModal'

export default {
  metaInfo () {
    return {
      title: `${this.playlist.data.name}`,
    }
  },
  components: {
    NoContent,
    Breadcrumb,
    Topbar,
    Sidebar,
  },
  layout: Dashboard,
  props: {
    playlist: {
      type: Object,
      required: true,
    },
    assets: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openModal () {
      this.$store.dispatch('modal/open', {
        modal: PlaylistModal,
        playlist: this.playlist.data,
        assets: this.assets.data,
      })
    },
    async confirmDelete(news) {
      const response = await this.$store.dispatch('modal/confirm', {
        title: `Are you sure you want to delete ${news.full_name}`,
        text: 'This item will be deleted immediately. You can\'t undo this action.',
      })

      if (response) {
        this.$inertia.delete(this.route('news.destroy', news.id))
      }
    },
    async confirmRestore(news) {
      const response = await this.$store.dispatch('modal/confirm', {
        title: `Are you sure you want to restore ${news.full_name}`,
        text: 'This item will be restored but any invoices or contracts may not be re-activated.',
      })

      if (response) {
        this.$inertia.post(this.route('news.restore', news.id))
      }
    },
  },
}
</script>

